import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { FormatDateTimePipe, tryParseToMoment } from './format-datetime.pipe';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'shopeeFormatDateTime' })
export class ShopeeFormatDateTimePipe
    extends FormatDateTimePipe
    implements PipeTransform
{
    transform(value: any, ...args: any[]): any {
        const parsedObj = this.tryParseToMoment(value);
        if (moment.isMoment(parsedObj)) {
            return this.formatMoment(parsedObj, ...args);
        }
        return parsedObj;
    }

    // Kept for the callers that inject this pipe to parse; the parser itself
    // lives in format-datetime.pipe.ts.
    tryParseToMoment(value: any) {
        return tryParseToMoment(value);
    }
}
